module.exports = __webpack_public_path__ + "static/media/mic-muted.82c0c0ed.svg";